<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="size_page.list_title" />

    <SizeList
      :sizes="filteredSizes"
      :stats="stats"
      :loading="loading"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteSize"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateSizeModal
      :open="showModal"
      :is-edit="!!selectedSize"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveSize"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateSizeModal from "../../components/Settings/SizeList/CreateSizeModal.vue";
import SizeList from "../../components/Settings/SizeList/SizeList.vue";
import { useSize } from "../../composables/useSize";

const {
  searchQuery,
  filteredSizes,
  stats,
  showModal,
  selectedSize,
  form,
  errors,
  loading,
  paginationConfig,
  fetchSizes,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  saveSize,
  deleteSize,
} = useSize();

onMounted(fetchSizes);
</script>
